module.exports = __webpack_public_path__ + "static/img/pic-logo.d21b0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/pic-logo.png
// module id = 832
// module chunks = 0